<template>
  <div class="grid gap-8">
    <ImageFigure
      v-for="(image, index) in images"
      :key="index"
      :src="image.src"
      :caption="image.caption"
    />
  </div>
</template>

<script setup lang="ts">
import ImageFigure from '~/scopes/campaign/components/UI/ImageFigure.vue'
import type { MetalImage } from '~/scopes/campaign/data/metals/types'

// One column: the old two-column bento only held together while every cell was
// cropped to a shared ratio, which is no longer allowed.
defineProps<{ images: MetalImage[] }>()
</script>
